import React from 'react';

const ProductCard = ({product}) => {
    return (
        <div className={"product-card product-card-" + (product.type_card && product.type_card)}>
            <a href={product.link_product ? product.link_product : "#"}>
                <div
                    className={"product-box xpy-10 xp-4 xp-lg-6 xpt-md-12 xpb-md-12 d-flex justify-content-center align-items-center flex-column position-relative"}>
                    <div className="product-price">
                        <span
                            className={product.discount ? "discount persian-number" : "d-none"}>{product.discount ? product.discount + "ت" : ""}</span>
                        <span className="total-price persian-number">{product.price ? product.price + "ت" : "تمام شد"}</span>
                    </div>
                    <div className="product-img xmb-3">
                        <img src={product.img && product.img} className='img-fluid'
                             alt={product.name && product.name}/>
                    </div>
                    <div className="product-text">
                        <h3 className="title">{product.name && product.name}</h3>
                    </div>
                    <div className="color-range">
                        <span className="range" style={{background: product.color_range_1}}/>
                        <span className="range" style={{background: product.color_range_2}}/>
                        <span className="range" style={{background: product.color_range_3}}/>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default ProductCard;
